import * as Yup from 'yup';
import { t } from 'i18next';

export const CustomizedMenuSchema = () => Yup.object().shape({
    selectPrice: Yup.string()
        .required(t('validation.required')),
    selectAvailability: Yup.string()
        .required(t('validation.required')),
});
